export const mapObject = <T extends object, R>(
  object: T,
  mapper: (value: T[keyof T], key: keyof T) => R
): { [K in keyof T]: R } => {
  return Object.fromEntries(
    Object.entries(object).map(([key, value]) => [key, mapper(value as T[keyof T], key as keyof T)])
  ) as { [K in keyof T]: R };
};